<template>
  <div class="tw-max-h-full">
    <GraphqlDataTable
      v-model:filters="filters"
      :query="query"
      :max-height-adjustment="30"
      :data-test="dataTest"
      :order-by="initialOrder"
      v-bind="$attrs"
      :filter-black-list="filterBlackList"
      display-all-args
    >
      <template v-if="$slots['no-results']" #no-results="slotProps: any">
        <slot name="no-results" v-bind="slotProps" />
      </template>
      <template v-if="$slots.action" #action="{ row }">
        <slot name="action" :row="row" />
      </template>
      <template v-if="$slots.filters" #filters>
        <slot name="filters" />
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { TypedQueryDocumentNode } from 'graphql/index'
import { PaymentRequestOrderByColumn, SortOrder } from '@/gql/graphql'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'

const props = withDefaults(
  defineProps<{
    query: TypedQueryDocumentNode
    dataTest?: string
    filterBlackList?: string[]
    initialOrder?: { field: PaymentRequestOrderByColumn; order: SortOrder }
  }>(),
  {
    dataTest: undefined,
    filterBlackList: () => ['accounts'],
    initialOrder: () => ({
      field: PaymentRequestOrderByColumn.IssuedAt,
      order: SortOrder.Desc,
    }),
  },
)

const initialOrder = computed(() => props.initialOrder)
const filters = defineModel<Record<string, any>>('filters', {
  default: () => ({}),
})
</script>

